
  import { Component, Vue } from "vue-property-decorator";
  import { IEmailSentModel, IPaginationSet } from "@/models";
  import { OpenRequestService, BlackListService } from "@/services/admin";
  import dayjs from "dayjs";

  @Component({
    name: "OpenRequests",
    components: {}
  })
  export default class OpenRequests extends Vue {
    fields: any[] = [
      {
        key: "selected",
        label: "",
        tdClass: "columnCheckbox"
      },
      {
        key: "adId",
        label: "ID",
        tdClass: "columnID"
      },
      {
        key: "emailFrom",
        label: "From"
      },
      {
        key: "emailTo",
        label: "To"
      },
      {
        key: "comments",
        label: "Comment"
      },
      {
        key: "action",
        label: "Action"
      }
    ];
    isLoading: boolean = true;
    pageSize: number = 20;
    currentPage: number = 1;
    selectAll: boolean = false;
    days: number = 30;
    result?: IPaginationSet<IEmailSentModel>;
    currentRequest?: IEmailSentModel = {} as IEmailSentModel;

    constructor() {
      super();
      this.isLoading = true;
      this.result = {
        page: 0,
        totalPages: 0,
        pageSize: 0,
        count: 0,
        items: [] as IEmailSentModel[],
        totalCount: 0
      } as IPaginationSet<IEmailSentModel>;
    }

    created() {
      setTimeout(() => {
        // wait for 500ms since vue router not finish
        // call this.$Progress.finish();
        this.loadData();
      }, 500);
    }
    onPageChange(page: number) {
      this.currentPage = page;
      this.loadData();
    }

    async loadData() {
      this.selectAll = false;
      this.isLoading = true;
      this.$Progress.start();
      const response = await OpenRequestService.GetOpenRequest(
        this.currentPage,
        this.pageSize
      );
      if (response.status === 200) {
        response.data.items.map(el => {
          el.selected = false;
          return el;
        });
        this.result = response.data;
      } else {
        this.generateError("Failed when loading data from server");
      }

      this.isLoading = false;
      this.$Progress.finish();
    }

    onBlacklist(email: IEmailSentModel) {
      this.currentRequest = email;
      this.$bvModal.show("blacklist-modal");
    }

    onDelete(email: IEmailSentModel) {
      this.currentRequest = email;
      this.$bvModal.show("delete-modal-request");
    }

    onSelectAll() {
      const { items } = this.result;
      items.map(el => {
        el.selected = this.selectAll;
        return el;
      });
      this.result = { ...this.result, items };      
    }
    async onAdSelected(item: any) {
      if (item.ad.expired === true && item.selected === true) {
        const expirationDate =
          item.ad.expirationDate !== null
            ? dayjs(item.ad.expirationDate).format("MM/DD/YYYY")
            : "";

        this.$bvModal
          .msgBoxConfirm(
            `This Ad expired on ${expirationDate}, do you still want to send this response or remove the response?`,
            {
              title: "Confirmation",
              size: "lg",
              buttonSize: "sm",
              okVariant: "primary",
              okTitle: "Send Response",
              cancelTitle: "Remove Response",
              footerClass: "p-2",
              hideHeaderClose: true,
              centered: true,
              noCloseOnBackdrop: true,
              noCloseOnEsc: true
            }
          )
          .then(value => {
            if (value === true) {
              this.onSendResposne(item);
            } else {
              this.onRemoveResponse(item);
            }
          })
          .catch(err => {
            // An error occurred
          });
      }
    }

    async onSendResposne(item: any) {
      this.$mainLoader.show();
      // get selected mail and collect the email id
      await OpenRequestService.SendMultipleMail([item.emailId]);
      this.$mainLoader.hide();
      this.generateSuccess(`Successfully send email requested`);
      this.currentPage = 1;
      this.loadData();
      this.selectAll = false;
    }
    async onRemoveResponse(item: any) {
      const index = this.result.items.findIndex(
        el => el.emailId === item.emailId
      );
      try {
        await OpenRequestService.RejectOpenRequest(item.emailId);
        this.result.items.splice(index, 1);
        this.result.totalCount -= 1;
        this.generateSuccess(
          `Successfully rejected request from ${item.emailFrom}`
        );
      } catch (err) {
        this.generateError(err.message);
      }
    }
    async onSendOpenRequest() {
      this.$mainLoader.show();
      // get selected mail and collect the email id
      const filteredEmail = this.result.items
        .filter(x => x.selected === true)
        .map(x => {
          return x.emailId;
        });
      await OpenRequestService.SendMultipleMail(filteredEmail);
      this.$mainLoader.hide();
      this.generateSuccess(`Successfully send email requested`);
      this.currentPage = 1;
      this.loadData();
    }

    async handleBlacklist() {
      const index = this.result.items.findIndex(
        el => el.emailFrom === this.currentRequest.emailFrom
      );
      let emails: string[] = [this.currentRequest.emailFrom];
      try {
        this.$bvModal.hide("blacklist-modal");
        await OpenRequestService.DeleteMultiple(emails);
        this.result.items.splice(index, 1);
        this.result.totalCount -= 1;
        this.generateSuccess(
          `Successfully add ${this.currentRequest.emailFrom} to blacklist`
        );
      } catch (err) {
        this.generateError(err.message);
      }
    }

    async handleDelete() {
      const index = this.result.items.findIndex(
        el => el.emailId === this.currentRequest.emailId
      );
      let emailId: number = this.currentRequest.emailId;
      try {
        this.$bvModal.hide("delete-modal-request");
        await OpenRequestService.DeleteOpenRequestAsync(emailId);
        this.currentPage = 1;
        this.loadData();
        this.generateSuccess(
          `Successfully delete current item`
        );
      } catch (err) {
        this.generateError(err.message);
      }
    }

    blacklistAll() {
      this.$bvModal.show("blacklist-all-modal");
    }

    deleteAll(){
      this.$bvModal.show("delete-all-modal");
    }

    async onBlacklistAllHandle() {
      const emails: Array<string> = [];
      this.result.items.forEach(el => {
        if (el.selected === true) {
          emails.push(el.emailFrom);
        }
      });
      if (emails.length === 0) {
        return false;
      }
      this.$bvModal.hide("blacklist-all-modal");
      this.$mainLoader.show();
      try {
        await BlackListService.AddMultiple(emails);
        this.generateSuccess(`Successfully add selected emails to blacklist`);
        this.currentPage = 1;
        this.loadData();
        this.selectAll = false;
      } catch (err) {
        this.generateError(err.message);
      }
      this.$mainLoader.hide();
    }

    async onDeleteAllHandle() {
      const adIds: Array<number> = [];
      this.result.items.forEach(el => {
        if (el.selected === true) {
          adIds.push(el.emailId);
        }
      });
      if (adIds.length === 0) {
        return false;
      }
      this.$bvModal.hide("delete-all-modal");
      this.$mainLoader.show();
      try {
        await OpenRequestService.DeleteOpenRequestMultipleAsync(adIds);
        this.generateSuccess(`Successfully delete selected items`);
        this.currentPage = 1;
        this.loadData();
        this.selectAll = false;
      } catch (err) {
        this.generateError(err.message);
      }
      this.$mainLoader.hide();
    }

    generateError(msg: string) {
      this.$bvToast.toast(`Error: ${msg}`, {
        title: "Error",
        variant: "danger",
        autoHideDelay: 5000
      });
    }
    generateSuccess(msg: string) {
      this.$bvToast.toast(`${msg}`, {
        title: "Information",
        variant: "primary",
        autoHideDelay: 5000
      });
    }
  }
